import type { PersonalDatasetItem } from '@dmp/api/api.types';
import { create } from 'zustand';

import { type CollectionState, createCollectionSlice } from './Collection/Collection.slice';
import { DataHubMyDatasetsTab, DataHubMyRequestsTab, DataHubTab } from './DataHub.types';
import { createOwnDatasetsSlice, type OwnDatasetsState } from './MyDataset/OwnDatasets/OwnDatasets.slice';
import {
  createProcuredDatasetsSlice,
  type ProcuredDatasetsState,
} from './MyDataset/ProcuredDatasets/ProcuredDatasets.slice';
import { createDatasetRequestSlice, type DatasetRequestState } from './MyRequests/DatasetRequests/DatasetRequest.slice';
import type { DownloadRequestsState } from './MyRequests/DownloadRequests/DownloadRequests.slice';
import { createDownloadRequestsSlice } from './MyRequests/DownloadRequests/DownloadRequests.slice';

type DataHubState = {
  activeTab: DataHubTab;
  activeMyRequestsTab: DataHubMyRequestsTab;
  activeMyDatasetsTab: DataHubMyDatasetsTab;
  isAddToCollectionModalVisible: boolean;
  datasetInOperation: PersonalDatasetItem | null;
};

export const initialDataHubState: DataHubState = {
  activeTab: DataHubTab.MY_DATASETS,
  activeMyRequestsTab: DataHubMyRequestsTab.DATASETS,
  activeMyDatasetsTab: DataHubMyDatasetsTab.DATASET_MARKETPLACE,
  isAddToCollectionModalVisible: false,
  datasetInOperation: null,
};

export const useDataHubStore = create<
  DataHubState &
    ProcuredDatasetsState &
    OwnDatasetsState &
    DatasetRequestState &
    DownloadRequestsState &
    CollectionState
>((...a) => {
  return {
    ...initialDataHubState,
    ...createProcuredDatasetsSlice(...a),
    ...createOwnDatasetsSlice(...a),
    ...createDatasetRequestSlice(...a),
    ...createDownloadRequestsSlice(...a),
    ...createCollectionSlice(...a),
  };
});

export const setActiveTab = (tab: DataHubTab) => {
  useDataHubStore.setState({ activeTab: tab });
};

export const setActiveMyRequestsTab = (tab: DataHubMyRequestsTab) => {
  useDataHubStore.setState({ activeMyRequestsTab: tab });
};

export const setActiveMyDatasetsTab = (tab: DataHubMyDatasetsTab) => {
  useDataHubStore.setState({ activeMyDatasetsTab: tab });
};

export const setIsAddToCollectionModalVisible = (isVisible: boolean) => {
  useDataHubStore.setState({ isAddToCollectionModalVisible: isVisible });
};

export const setDatasetInOperation = (dataset: PersonalDatasetItem | null) => {
  useDataHubStore.setState({ datasetInOperation: dataset });
};

export const resetDataHubState = () => {
  useDataHubStore.setState(initialDataHubState);
};
